import { DropOff, DropOffOpeningTime, IDropOff, IDropOffAllParams, IDropOffDetailParams } from '@packlink/packlink-sdk';
import Packlink from '@sdk';
import BluebirdPromise from 'bluebird';
import { ReduxAction } from '@store';
import { IDropOffPoint } from '@packlink/cartography';

const mapDropOff = (dropOff: DropOff): IDropOffPoint => {
    return {
        address: dropOff.address as string,
        businessName: dropOff.businessName as string,
        city: dropOff.city as string,
        id: dropOff.id ? dropOff.id.toString() : '',
        lat: dropOff.lat as number,
        lng: dropOff.lng as number,
        openingTimes: (dropOff.openingTimes as DropOffOpeningTime[]).map((openingTime: DropOffOpeningTime) => {
            return {
                day: `drop-off.address.weekday-${openingTime.day}`,
                time: openingTime.time || null,
            };
        }),
        zip: dropOff.zipCode as string,
    };
};

export const getDropOffPoints = (params: IDropOffAllParams): BluebirdPromise<IDropOffPoint[]> => {
    return Packlink.v1.dropOffs.all(params).then((dropOffs: DropOff[]) => dropOffs.map(mapDropOff));
};

export const getDropoffPoint = (params: IDropOffDetailParams): BluebirdPromise<DropOff<IDropOff>> => {
    return Packlink.v1.dropOffs.detail(params);
};

export const getDropOffPointsAction =
    (params: IDropOffAllParams): ReduxAction<BluebirdPromise<IDropOffPoint[] | void>> =>
    (): BluebirdPromise<IDropOffPoint[] | void> => {
        return getDropOffPoints(params);
    };
